<template>
  <Transition name="slide-down">
    <div v-if="show" class="update-notification">
      <div class="update-notification-content">
        <i class="bi bi-arrow-repeat fs-3 me-3"></i>
        <div class="update-notification-text">
          <div class="fw-bold">New version available</div>
          <div class="text-muted small">Update now to get the latest features and fixes</div>
        </div>
        <button @click="handleUpdate" class="btn btn-sm btn-light-primary ms-4">Update Now</button>
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
interface Props {
  show: boolean
}

interface Emits {
  (e: 'update'): void
}

defineProps<Props>()
const emit = defineEmits<Emits>()

const handleUpdate = () => {
  emit('update')
}
</script>

<style scoped lang="scss">
.update-notification {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1050;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  padding: 1rem;
}

.update-notification-content {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 768px) {
    flex-direction: column;
    text-align: center;

    .ms-4 {
      margin-left: 0 !important;
      margin-top: 0.75rem;
    }
  }
}

.update-notification-text {
  flex: 1;
}

// Transition animations
.slide-down-enter-active,
.slide-down-leave-active {
  transition: all 0.3s ease-out;
}

.slide-down-enter-from {
  transform: translateY(-100%);
  opacity: 0;
}

.slide-down-leave-to {
  transform: translateY(-100%);
  opacity: 0;
}
</style>
